import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Dropdown, Menu, notification } from "antd";
import { faEllipsis } from "@fortawesome/free-solid-svg-icons";
import Pagination from "@mui/material/Pagination";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import TobNavBar from "../../DashBaord/Top_navbar";
import { useNavigate } from "react-router-dom";
import { S3_BASE_URL } from "../../../config/constants";
import { DeleteOutlined } from "@ant-design/icons";

import {
  InfoCircleOutlined,
  CheckCircleOutlined,
  LikeOutlined,
  DislikeOutlined,
} from "@ant-design/icons";

import SkeltonList from "../../../components/SkeltonEffect/list";
import { list, changeStatus, deleteTeam } from "../../../controllers/cms/teams";
import { getPage, statusMessage } from "../../../controllers/common";

function TeamsListPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TeamsListPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function TeamsList() {
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const targetRef = useRef(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [ALLLISTDATA, setListData] = useState([]);
  const [TOTALPAGES, setTotalPages] = useState(1);
  const [LIMIT] = useState(10);
  const [SKIP, setSkip] = useState(0);
  const [showRequest, setShowRequest] = useState("");

  const handleEdit = async (item = {}) => {
    navigate("/cms/team/addeditdata", { state: item });
  };

  /*********************************************************
   *  This function is use to fetch team member list
   *********************************************************/
  const getList = async () => {
    try {
      setIsLoading(true);
      setListData([]);
      const options = {
        type: "",
        condition: {
          ...(showRequest ? { status: showRequest } : null),
        },
        select: {},
        sort: { status: 1, _id: -1 },
        skip: SKIP ? SKIP : 0,
        limit: LIMIT ? LIMIT : 10,
      };
      const listData = await list(options);
      if (listData.status === true) {
        if (listData.result.length > 0) {
          setListData(listData?.result);
          setTotalPages(getPage(listData?.count));
        } else {
          setListData([]);
          setTotalPages(getPage(1));
        }
      } else {
        setListData([]);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
    setSkip((newPage - 1) * LIMIT);
    targetRef.current.scrollIntoView({ behavior: "smooth" });
  };

  const handleStatusChnage = async (status = "", id) => {
    try {
      const options = {
        url: `cms/team/change-status`,
        postData: { id: id, status: status },
      };
      const res = await changeStatus(options);
      if (res.status === true) {
        notification.open({
          message: "Status Changed.",
          description: `Status Changed successfully.`,
          placement: "topRight",
          icon: <CheckCircleOutlined style={{ color: "green" }} />,
          duration: 2,
        });
      } else {
        notification.open({
          message: "Opps!",
          description: `${res?.message}`,
          placement: "topRight",
          icon: <InfoCircleOutlined style={{ color: "red" }} />,
          duration: 2,
        });
      }
    } catch (error) {
      notification.open({
        message: "Opps!",
        description: `Operation not performed yet! please try in some time.`,
        placement: "topRight",
        icon: <InfoCircleOutlined style={{ color: "red" }} />,
        duration: 2,
      });
    }
    getList();
  };

  const handleDelete = async (deleteId) => {
    try {
      if (deleteId) {
        const res = await deleteTeam({ id: deleteId });
        if (res.status === true) {
          notification.open({
            message: "Deleted!",
            description: "Data Deleted Successfully.",
            placement: "topRight",
            duration: 2,
            icon: <DeleteOutlined style={{ color: "green" }} />,
          });
        } else {
          notification.open({
            message: "Oops!!",
            description: "Please try again.",
            placement: "topRight",
            duration: 2,
            icon: <DeleteOutlined style={{ color: "red" }} />,
          });
        }
      }
    } catch (error) {
      notification.open({
        message: "Error",
        description: "An error occurred while deleting. Please try again.",
        placement: "topRight",
        duration: 2,
        icon: <DeleteOutlined style={{ color: "red" }} />,
      });
    }
    getList();
  };

  const dropdownMenu = (items) => {
    return (
      <Menu>
        {items?.status === "I" && (
          <Menu.Item key="02" onClick={() => handleStatusChnage("A", items._id)}>
            <LikeOutlined /> <span className="show_span">Active</span>
          </Menu.Item>
        )}
        {items?.status === "A" && (
          <Menu.Item key="02" onClick={() => handleStatusChnage("I", items._id)}>
            <DislikeOutlined /> <span className="show_span">Inactive</span>
          </Menu.Item>
        )}
        <Menu.Item key="01" onClick={() => handleEdit(items)}>
          <span className="show_span_edit">Edit</span>
        </Menu.Item>
        <Menu.Item key="0" onClick={() => handleDelete(items?._id)}>
          <DeleteOutlined /> <span className="show_span_edit">Delete</span>
        </Menu.Item>
      </Menu>
    );
  };

  useEffect(() => {
    getList();
    targetRef.current.scrollIntoView({ behavior: "smooth" });
    document.title = "KC High Admin || Leadership Team List";
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, showRequest]);

  return (
    <div className="container-fluid" ref={targetRef}>
      <TobNavBar title={"Leadership Team"}></TobNavBar>
      <div className="inventory_tabs_main_div">
        <Box sx={{ width: "100%" }}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <div className="inventory_all_tabs">
              <div className="all_tabs_value">
                <Tabs value={value} onChange={handleChange} className="item_tabs_main_container">
                  <Tab label="All" className="tabs_main_contnet" {...a11yProps(0)} onClick={() => setShowRequest("")} />
                  <Tab label="Active" className="tabs_main_contnet" {...a11yProps(1)} onClick={() => setShowRequest("A")} />
                  <Tab label="Inactive" className="tabs_main_contnet" {...a11yProps(2)} onClick={() => setShowRequest("I")} />
                </Tabs>
              </div>
              <div className="fa_filter_rating_review filter_img_and_add_btn_main">
                <div onClick={() => handleEdit()}>
                  <button type="button" className="btn btn-dark">
                    <span className="request_new_categories">Add New</span>
                  </button>
                </div>
              </div>
            </div>
          </Box>
          <TeamsListPanel>
            <div>
              <div id="content-wrapper" className="d-flex flex-column">
                <div className="card mb-4">
                  <div className="card-body all_card_body_padding">
                    <div className="table-responsive">
                      <table className="table table-bordered" id="dataTable" width="100%" cellSpacing="0">
                        <thead className="all_table_form">
                          <tr>
                            <th>S.no.</th>
                            <th>Photo</th>
                            <th>Name</th>
                            <th>Designation</th>
                            <th>Status</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {ALLLISTDATA?.length > 0 ? (
                            ALLLISTDATA.map((items, index) => (
                              <tr key={items._id || index}>
                                <td>{(currentPage - 1) * 10 + index + 1}</td>
                                <td className="admin_user_list_date">
                                  <img src={S3_BASE_URL + items?.image} alt={items?.name} style={{ width: "70px" }} />
                                </td>
                                <td>{items?.name}</td>
                                <td>{items?.designation}</td>
                                <td className="admin_user_list_date" dangerouslySetInnerHTML={{ __html: statusMessage(items.status) }}></td>
                                <td>
                                  <Dropdown overlay={() => dropdownMenu(items)} placement="bottomLeft" arrow>
                                    <FontAwesomeIcon icon={faEllipsis} />
                                  </Dropdown>
                                </td>
                              </tr>
                            ))
                          ) : isLoading ? (
                            <SkeltonList row={10} col={6} />
                          ) : (
                            <tr>
                              <td colSpan="6" className="img-center">
                                No data found !
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                      <div className="table_pagination_sales_order">
                        <Pagination count={TOTALPAGES} onChange={handlePageChange} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </TeamsListPanel>
        </Box>
      </div>
    </div>
  );
}
